/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationUserSessionIssuersCreate } from "../funcs/organizationUserSessionIssuersCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateOrganizationUserSessionIssuerRequest,
  CreateOrganizationUserSessionIssuerSecurity,
} from "../models/operations/createorganizationusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateOrganizationUserSessionIssuerMutationVariables = {
  request: CreateOrganizationUserSessionIssuerRequest;
  security?: CreateOrganizationUserSessionIssuerSecurity | undefined;
  options?: RequestOptions;
};

export type CreateOrganizationUserSessionIssuerMutationData = UserSessionIssuer;

export type CreateOrganizationUserSessionIssuerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createIssuer organizationUserSessionIssuers
 *
 * @remarks
 * Create an organization-owned user_session_issuer. Requires org:admin.
 */
export function useCreateOrganizationUserSessionIssuerMutation(
  options?: MutationHookOptions<
    CreateOrganizationUserSessionIssuerMutationData,
    CreateOrganizationUserSessionIssuerMutationError,
    CreateOrganizationUserSessionIssuerMutationVariables
  >,
): UseMutationResult<
  CreateOrganizationUserSessionIssuerMutationData,
  CreateOrganizationUserSessionIssuerMutationError,
  CreateOrganizationUserSessionIssuerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateOrganizationUserSessionIssuerMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateOrganizationUserSessionIssuer(): MutationKey {
  return ["@gram/client", "organizationUserSessionIssuers", "create"];
}

export function buildCreateOrganizationUserSessionIssuerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateOrganizationUserSessionIssuerMutationVariables,
  ) => Promise<CreateOrganizationUserSessionIssuerMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateOrganizationUserSessionIssuer(),
    mutationFn: function createOrganizationUserSessionIssuerMutationFn({
      request,
      security,
      options,
    }): Promise<CreateOrganizationUserSessionIssuerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(organizationUserSessionIssuersCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
